module.exports = __webpack_public_path__ + "static/media/build.0ecbdf78.svg";